import { render, staticRenderFns } from "./NotenausweisPDFModal.vue?vue&type=template&id=0b56d5f7&"
import script from "./NotenausweisPDFModal.vue?vue&type=script&lang=js&"
export * from "./NotenausweisPDFModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports